import _ from 'lodash'
import { isEmail, isObjectNotEmpty, isStringNotNull } from '../../utils/tools'

import {
  DELIVERY_FEE,
  ERROR_UPDATE_CONFIG,
  ERROR_WRONG_FIELD_INFORMATIONS,
  ERROR_WRONG_INFORMATIONS,
  ERROR_WRONG_PHONE_NUMBER,
  INPUT_PHONE_MAX_LENGTH,
  MANAGEMENT_FEE,
  SUCCESS_UPDATE_TEXT
} from '../../constants'
import { sendCloudWatchAlert } from '../../utils/applicationError'
import { updateSupportConfigForShop } from '../../apis/shop.service'
import { showNotification } from '../Notification/Notification.view'
import { hasExternalIntegration } from 'src/utils/externalIntegration'

export const initDataConfig = async (newProps, component) => {
  const { configurations } = newProps;
  const { support = {}, configuration = {}, cancelFee } = configurations;
  const { refs = {} } = configuration;
  const { charges = {} } = refs;
  const { deliveryFeeRef = {}, managementFeeRef = {} } = charges;
  const data = {
    support,
    deliveryFeeRef,
    managementFeeRef,
    cancelFee: isObjectNotEmpty(cancelFee)
      ? cancelFee
      : {
        type: '%',
        value: 100
      }
  };
  component.setState({ data });
};

export const handleChangeManagementFeeRef = (event, component) => {
  const { id, value } = event.target;
  component.setState(prevState => {
    const { data, validationMessage } = prevState;
    let statusError = 'is-invalid';
    if (value) {
      statusError = value !== '' ? 'is-valid' : 'is-invalid';
    }
    return {
      data: {
        ...data,
        [id]: { key: id === 'deliveryFeeRef' ? DELIVERY_FEE : MANAGEMENT_FEE, ref: value }
      },
      validationMessage: {
        ...validationMessage,
        [id]: { ...validationMessage[id], text: statusError }
      }
    };
  });
};

export const handleChangeInfoContact = (event, component) => {
  const { id, value } = event.target;
  component.setState(prevState => {
    const { data, validationMessage } = prevState;
    let statusError = 'is-invalid';
    if (value) {
      switch (id) {
        case 'email': {
          statusError = isEmail(value) ? 'is-valid' : 'is-invalid';
          break;
        }
        case 'number': {
          statusError = value.length === INPUT_PHONE_MAX_LENGTH ? 'is-valid' : 'is-invalid';
          break;
        }
        default: {
          statusError = value.length > 0 ? 'is-valid' : 'is-invalid';
          break;
        }
      }
    }
    return {
      data: {
        ...data,
        support: { ...data.support, [id]: value }
      },
      validationMessage: {
        ...validationMessage,
        [id]: { ...validationMessage[id], text: statusError }
      }
    };
  });
};

export const handleSubmitData = async (e, component) => {
  const { openErrorModal } = component.props;
  const { data, validationMessage } = component.state;
  const {
    support,
    managementFeeRef = {},
    deliveryFeeRef = {},
    cancelFee
  } = data;
  cancelFee.value = parseInt(cancelFee.value, 10)
  try {
    if (component.isPhoneIncorrect) {
      openErrorModal(ERROR_WRONG_PHONE_NUMBER);
      return;
    }
    component.setState({ isLoading: true });
    e.preventDefault();
    e.stopPropagation();
    if (
      (!isStringNotNull(managementFeeRef.ref) || !isStringNotNull(deliveryFeeRef.ref)) &&
      hasExternalIntegration()
    )
      openErrorModal(ERROR_WRONG_INFORMATIONS);
    else if (_.find(validationMessage, input => input && input.text === 'is-invalid') || support.number.length < INPUT_PHONE_MAX_LENGTH)
      openErrorModal(ERROR_WRONG_FIELD_INFORMATIONS);
    else {
      const dataToFirebase = {
        support,
        charges: { managementFeeRef, deliveryFeeRef },
        cancelFee
      };
      await updateSupportConfigForShop(dataToFirebase);
      showNotification(
        'light',
        'ltr',
        'primary',
        SUCCESS_UPDATE_TEXT,
        `Les paramètres du magasin ont bien été modifiés.`
      );
    }
  } catch (error) {
    sendCloudWatchAlert(`Error changing general configuration ${error}`);
    openErrorModal(ERROR_UPDATE_CONFIG);
  }
  component.setState({ isLoading: false });
};

export const onFocusOnBlur = (event, value, component) => {
  const { id } = event.target;
  const { validationMessage } = component.state;
  component.setState({
    validationMessage: {
      ...validationMessage,
      [id]: { ...validationMessage[id], isFocused: value }
    }
  });
};
export const handleChangeCanceledFees = (event, component) => {
  const { value, id } = event.target;
  const { data } = component.state;
  const { cancelFee = {} } = data;
  const { type = '€' } = cancelFee;
  if (id === 'type')
    component.setState({
      data: {
        ...data,
        cancelFee: {
          ...cancelFee,
          [id]: value,
          value: 0
        }
      }
    });
  else
    component.setState({
      data: {
        ...data,
        cancelFee: {
          ...cancelFee,
          [id]: type === '%' ? (value > 100 ? 100 : value) : parseFloat(value.slice(0, 5))
        }
      }
    });
};

export const handleChangePhoneNumber = (phone, component) => {
  component.setState(prevState => {
    const { data } = prevState;

    return {
      data: {
        ...data,
        support: { ...data.support, number: phone },

      },

    };
  });
};
